"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthVerifyContactCodeRequest = void 0;
var React = require("react");
var react_intl_1 = require("react-intl");
var final_form_1 = require("final-form");
var chainAuthErrorMapping_1 = require("../utils/chainAuthErrorMapping");
var AuthVerifyContactCodeRequest = (function (_super) {
    __extends(AuthVerifyContactCodeRequest, _super);
    function AuthVerifyContactCodeRequest() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            error: null,
            loading: false,
        };
        _this.requestCode = function (attribute) {
            _this.setState({ error: null, loading: true });
            chainAuthErrorMapping_1.chainAuthErrorMapping(_this.props.onRequestContactVerificationCode)(attribute).then(function (data) {
                _this.setState({
                    error: (data && data[final_form_1.FORM_ERROR]) || null,
                    loading: false,
                });
            });
        };
        return _this;
    }
    AuthVerifyContactCodeRequest.prototype.render = function () {
        var _this = this;
        var _a = this.props, additionalData = _a.additionalData, authData = _a.authData, authState = _a.authState, onSkipVerifyContact = _a.onSkipVerifyContact, Components = _a.Components;
        if (['verifyContact'].indexOf(authState) < 0 || !!additionalData) {
            return null;
        }
        var unverified = authData.unverified;
        var _b = this.state, error = _b.error, loading = _b.loading;
        return (React.createElement(Components.Wrapper, { footer: React.createElement(Components.ClickableText, { onClick: function () { return onSkipVerifyContact(); } },
                React.createElement(react_intl_1.FormattedMessage, { id: "COGNITO_AUTH.SKIP" })), header: React.createElement(react_intl_1.FormattedMessage, { id: "COGNITO_AUTH.VERIFY_CONTACT" }, function (txt) { return React.createElement(Components.Headline, null, txt); }), loading: loading },
            React.createElement(react_intl_1.FormattedMessage, { id: "COGNITO_AUTH.VERIFY_CONTACT_DESCRIPTION", tagName: "p" }),
            Object.keys(unverified).map(function (item) { return (React.createElement(Components.Button, { key: "verification-button-" + item, onClick: function () { return _this.requestCode(item); } },
                React.createElement(react_intl_1.FormattedMessage, { id: "COGNITO_AUTH.REQUEST_VERIFICATION_" + item.toUpperCase() }))); }),
            error && React.createElement(Components.ErrorMessage, { message: error })));
    };
    return AuthVerifyContactCodeRequest;
}(React.Component));
exports.AuthVerifyContactCodeRequest = AuthVerifyContactCodeRequest;
//# sourceMappingURL=AuthVerifyContactCodeRequest.js.map